import { useContext } from "react";
import "./UserProfileStyle.css";
import { ProductContext } from "../../Contexts/ProductContext";

const UserProfile = () => {
  const { userLogout } = useContext(ProductContext);

  return (
    <div className="user-profile-container">
      <div className="user-profile-body">
        <p>
          <span>Name: </span>
          <span style={{ color: "var(--dark-background-color)", fontWeight: "bold", fontSize: "0.9rem" }}>{localStorage.getItem("custName")}</span>
        </p>
        <p>
          <span>Email: </span>
          <span style={{ color: "var(--dark-background-color)", fontWeight: "bold", fontSize: "0.9rem" }}>{localStorage.getItem("custEmail")}</span>
        </p>
        <p>
          <span>Mobile: </span>
          <span style={{ color: "var(--dark-background-color)", fontWeight: "bold", fontSize: "0.9rem" }}>{localStorage.getItem("custMob")}</span>
        </p>
        <button onClick={userLogout}>Sign out</button>
      </div>
    </div>
  );
};
export { UserProfile };
